import { NgModule } from '@angular/core';
import { UbudStorageModule } from '@ubud/storage';
import { RegisterService } from '@lemsar/auth/domains/services/register.service';
import { CompanyService } from '@lemsar/common/domains/services/company.service';

@NgModule({
    imports: [UbudStorageModule],
    providers: [RegisterService, CompanyService],
})
export class LemsarAuthDomainModule {}



// WEBPACK FOOTER //
// ./src/lemsar/auth/domains/module.ts